import { Component, forwardRef, inject, input } from '@angular/core';
import { UserItemDto, UserService } from '@artemis-software/wr-api';
import { currentTenantId } from '@/utils/admin-utils';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { Router } from '@angular/router';
import {
  AssignmentType,
  PickListBehaviour,
} from '@shared/form-controls/generic-pick-list/generic-pick-list.component';
import { firstValueFrom } from 'rxjs';

@Component({
  standalone: false,
  selector: 'wr-user-pick-list',
  styleUrls: ['./user-pick-list.component.scss'],
  templateUrl: './user-pick-list.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserPickListComponent),
      multi: true,
    },
  ],
})
export class UserPickListComponent extends AbstractFormControl<UserItemDto[]> implements PickListBehaviour<UserItemDto> {
  readonly userService = inject(UserService);
  readonly router = inject(Router);

  readonly getAssignmentTypeFunction = input.required<(user: UserItemDto) => AssignmentType>();

  readonly currentTenantId = currentTenantId();

  readonly users = asyncComputed(() =>
    this.userService.findAll({ tenantId: this.currentTenantId() }));

  readonly isPaginated = false;

  getAllItems(): Promise<UserItemDto[]> {
    const tenantId = this.currentTenantId();
    return firstValueFrom(this.userService.findAll({ tenantId: tenantId }));
  }

  getAssignmentType(item: UserItemDto): AssignmentType {
    return this.getAssignmentTypeFunction()(item);
  }

  getDisplayName(item: UserItemDto): string {
    return item.fullName;
  }

  getFirstAdditionalInfo(item: UserItemDto): string {
    return item.userName || '';
  }

  getThirdAdditionalInfo(item: UserItemDto): string {
    return item.email || '';
  }

}
